/* tslint:disable */
/* eslint-disable */
/**
 * All APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ActiveWidgetContext } from './ActiveWidgetContext';
import {
    ActiveWidgetContextFromJSON,
    ActiveWidgetContextFromJSONTyped,
    ActiveWidgetContextToJSON,
    ActiveWidgetContextToJSONTyped,
} from './ActiveWidgetContext';

/**
 * 
 * @export
 * @interface SendMessageRequest
 */
export interface SendMessageRequest {
    /**
     * 
     * @type {string}
     * @memberof SendMessageRequest
     */
    message: string;
    /**
     * 
     * @type {boolean}
     * @memberof SendMessageRequest
     */
    hidden?: boolean;
    /**
     * 
     * @type {ActiveWidgetContext}
     * @memberof SendMessageRequest
     */
    activeWidgetContext?: ActiveWidgetContext;
}

/**
 * Check if a given object implements the SendMessageRequest interface.
 */
export function instanceOfSendMessageRequest(value: object): value is SendMessageRequest {
    if (!('message' in value) || value['message'] === undefined) return false;
    return true;
}

export function SendMessageRequestFromJSON(json: any): SendMessageRequest {
    return SendMessageRequestFromJSONTyped(json, false);
}

export function SendMessageRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): SendMessageRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'message': json['message'],
        'hidden': json['hidden'] == null ? undefined : json['hidden'],
        'activeWidgetContext': json['activeWidgetContext'] == null ? undefined : ActiveWidgetContextFromJSON(json['activeWidgetContext']),
    };
}

export function SendMessageRequestToJSON(json: any): SendMessageRequest {
    return SendMessageRequestToJSONTyped(json, false);
}

export function SendMessageRequestToJSONTyped(value?: SendMessageRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'message': value['message'],
        'hidden': value['hidden'],
        'activeWidgetContext': ActiveWidgetContextToJSON(value['activeWidgetContext']),
    };
}

